import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import Observer from '../components/observer';

class Inspiration extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    
    this.element = element
    this.el = $(element)

    this.ref = {
      decor: null, 
      video: null , 
      container: null
    }

  }

  mount() {

    this.observer = new Observer({
        rootMargin: '-1%',
        callback: (visible, target, entry) => {
            //   console.log(target, entry);
            if (visible) {
                this.ref.video && this.ref.video.play()
            } else {
                this.ref.video && this.ref.video.pause()
            }
        }
    });
    this.observer.add(this.ref.video);

    this.iobserver = new Observer({
      rootMargin: '-1%'
    });
    this.iobserver.add('.insp__img')


    this.anim1 = gsap.fromTo(this.ref.decor, {
        yPercent: -this.ref.decor.dataset.offset
     },{
        yPercent: this.ref.decor.dataset.offset,
        scrollTrigger: {
            trigger: this.ref.container,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    })

      
}





resize(){
  
}

  unmount() {

this.observer.disconnect()
this.iobserver.disconnect()
this.anim1.kill()

  }


}

module.exports = Inspiration
